/**
 * OptionsBodySkeleton
 * 
 * @Author: Focci
 * @Date: 2023-08-29 15:00:10
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-29 15:00:10
 */

// import PropTypes from 'prop-types'
import { Skeleton } from '@comp/material'

export default function OptionsBodySkeleton() {
  return (
    <div className="mt-8">
      <Skeleton variant="text" style={{ fontSize: '1.4rem', width: '80%' }} />
      <Skeleton variant="text" style={{ fontSize: '1.4rem', width: '30%' }} />
      <Skeleton variant="text" style={{ fontSize: '0.9rem' }} />
      <div className="flex gap-4 mt-8">
        <Skeleton variant="rectangular" style={{ width: '7rem', height: '9rem', borderRadius: '.4rem' }} />
        <Skeleton variant="rectangular" style={{ width: '7rem', height: '9rem', borderRadius: '.4rem' }} />
        <Skeleton variant="rectangular" style={{ width: '7rem', height: '9rem', borderRadius: '.4rem' }} />
      </div>
    </div>
  )
}

// OptionsBodySkeleton.propTypes = {
//   className: PropTypes.string,
// }
